import React from 'react';

declare global {
  interface Window {
    adsbygoogle: any[];
  }
}

const GoogleAdBanner: React.FC = () => {
  const adClient = process.env.REACT_APP_GOOGLE_AD_CLIENT;
  const adSlot = process.env.REACT_APP_GOOGLE_AD_BANNER_SLOT;

  return (
    <div>
      <ins
        className="adsbygoogle"
        style={{ display: 'block' }}
        data-ad-client={adClient}
        data-ad-slot={adSlot}
        data-ad-format="auto"
        data-full-width-responsive="true"
      ></ins>
    </div>
  );
};

export default GoogleAdBanner;
